import React from 'react'
import './Foot.css'

export const Footer = () => (
  <footer
    className="bg-dark text-light py-3 mt-3 "
    // style={{
    //   marginBottom: '0px',
    //   position: 'relative',
    // }}
  >
    <p className="text-center">
      <h3>SANEDROID</h3>
      Contact Us - sanedroid@gmail.com
    </p>
    <p className="text-center">
      Copyright &copy;{new Date().getFullYear()} Sanedroid.tech INC | All rights
      reserved
    </p>
  </footer>
)
